import { useStorage } from '@vueuse/core'

type User =
  | AuthUser
  | Record<string, never>

interface TokenData { refresh_token: string, refresh_exp: number }

export const useAuthStore = defineStore('auth', {
  state() {
    return {
      loggedIn: useStorage('loggedIn', false, localStorage),
      user: useStorage('user', {}, localStorage),
      refreshToken: useStorage('refresh_token', '', localStorage),
      refreshExp: 0,
    }
  },
  getters: {
    isLoggedIn(state): boolean {
      return state.loggedIn
    },
    authenticatedUser(state): User {
      return state.user
    },
    tokens(state): { refresh_token: string, refresh_exp: number } {
      return {
        refresh_token: useNuxtApp()
          .$buffer.from(state.refreshToken, 'base64')
          .toString('utf8'),
        refresh_exp: state.refreshExp,
      }
    },
  },
  actions: {
    setUser(user: User) {
      this.user = user
      this.loggedIn = true
    },
    setTokens({ refresh_token, refresh_exp }: TokenData) {
      this.refreshToken = useNuxtApp()
        .$buffer.from(refresh_token, 'utf-8')
        .toString('base64')
      this.refreshExp = refresh_exp
    },
    logout() {
      console.info('Logging out from the store')
      this.loggedIn = false
      this.user = {}
      this.setTokens({ refresh_token: '', refresh_exp: 0 })
      localStorage.removeItem('tenant')
    },
  },
})
